/**
 * Custom logging utility that provides styled console output when debugging is enabled.
 * Set DEBUG = false in production to eliminate logging cost.
 */
(function (g) {
  const DEBUG = false, // <-- TURNED OFF FOR PRODUCTION
    styles = {
      success: "background: darkgreen; color: white; padding: 2px 6px; border-radius: 3px",
      error: "background: darkred; color: white; padding: 2px 6px; border-radius: 3px",
      warning: "background: darkorange; color: white; padding: 2px 6px; border-radius: 3px",
      info: "background: blue; color: white; padding: 2px 6px; border-radius: 3px"
    };

  function logFn() {
    if (!DEBUG) return;
    // eslint-disable-next-line no-console
    console.log.apply(console, arguments);
  }

  function collapse(type, data, title = "Log", status = "info") {
    if (!DEBUG) return;
    const style = styles[status] || styles.info;
    // eslint-disable-next-line no-console
    console.groupCollapsed("%c " + title, style);
    if (type === "table" && console.table) {
      // eslint-disable-next-line no-console
      console.table(data);
    } else {
      // eslint-disable-next-line no-console
      console.log(data);
    }
    // eslint-disable-next-line no-console
    console.groupEnd();
  }

  logFn.table = function (data, title, status) {
    collapse("table", data, title, status);
  };
  logFn.collapse = function (data, title, status) {
    collapse("log", data, title, status);
  };

  g.log = logFn;
})(typeof window !== "undefined" ? window : globalThis);


/**
 * Initializes and manages a Slick carousel with separate mobile and desktop configurations.
 * Uses a throttled resize listener to avoid excessive work on resize.
 *
 * @param {jQuery} $carousel - The carousel element(s).
 * @param {Object} mobileOptions - Slick options for mobile view.
 * @param {number} breakpoint - The breakpoint to switch between mobile and desktop configurations.
 * @param {Object|null} desktopOptions - Slick options for desktop view. If null, unslick on desktop.
 */
function handleResponsiveCarousel($carousel, mobileOptions, breakpoint = 1024, desktopOptions = null) {
  if (!$carousel || !$carousel.length) return;

  let currentView = null;
  let resizeTimeout = null;

  function initializeCarousel() {
    if (!$carousel.length) return;

    const isDesktop = window.innerWidth >= breakpoint;

    if (isDesktop) {
      if (currentView !== "desktop") {
        if ($carousel.hasClass("slick-slider")) $carousel.slick("unslick");
        if (desktopOptions) $carousel.slick(desktopOptions);
        currentView = "desktop";
      }
    } else {
      if (currentView !== "mobile") {
        if ($carousel.hasClass("slick-slider")) $carousel.slick("unslick");
        $carousel.slick(mobileOptions);
        currentView = "mobile";
      }
    }
  }

  // Initial setup
  initializeCarousel();

  // Throttled resize handler
  $(window).on("resize.responsiveCarousel", function () {
    if (resizeTimeout) window.clearTimeout(resizeTimeout);
    resizeTimeout = window.setTimeout(initializeCarousel, 150);
  });
}

// Function to copy text to clipboard
function copyToClipboard(text) {
  var $tempInput = $("<input>");
  $("body").append($tempInput);
  $tempInput.val(text).select();
  document.execCommand("copy");
  $tempInput.remove();
}


// Delay non-critical UI setup until after DOM is ready
$(function () {
  const useChevron = false;
  const icons = {
    arrow_left: "https://cdn.shopify.com/s/files/1/0623/4485/5760/files/Arrow_Left.svg?v=1744058170",
    arrow_right: "https://cdn.shopify.com/s/files/1/0623/4485/5760/files/Arrow_Right.svg?v=1744058170",
    chevron_left: "https://cdn.shopify.com/s/files/1/0679/7135/0705/files/Chevron_Left.png?v=1737122129",
    chevron_right: "https://cdn.shopify.com/s/files/1/0679/7135/0705/files/Chevron_Right.png?v=1737122129"
  };

  const buttons = {
    prevArrow:
      "<button type='button' aria-label='Arrow Left' class='slick-prev pull-left'>" +
      "<img class='left_arrow' src='" + (useChevron ? icons.chevron_left : icons.arrow_left) + "' alt='arrow'/></button>",
    nextArrow:
      "<button type='button' aria-label='Arrow Right' class='slick-next pull-right'>" +
      "<img class='right_arrow' src='" + (useChevron ? icons.chevron_right : icons.arrow_right) + "' alt='arrow'/></button>"
  };

  // ===== Carousels: only initialize when elements are present =====

  const $testimonials = $(".testimonials__cards");
  if ($testimonials.length) {
    $testimonials.slick({
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: "40px",
      arrows: true,
      dots: true,
      prevArrow: buttons.prevArrow,
      nextArrow: buttons.nextArrow,
      responsive: [
        {
          breakpoint: 678,
          settings: {
            slidesToShow: 1,
            centerPadding: "30px"
          }
        }
      ]
    });
  }

  const $videoReviewsWrapper = $(".video-reviews__wrapper");
  if ($videoReviewsWrapper.length) {
    $videoReviewsWrapper.slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      variableWidth: true,
      prevArrow: buttons.prevArrow,
      nextArrow: buttons.nextArrow,
      responsive: [
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 678,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  }

  const $pdpShowcase = $(".product-showcase__products.pdp-description");
  if ($pdpShowcase.length) {
    $pdpShowcase.slick({
      infinite: true,
      dots: true,
      arrows: true,
      prevArrow: buttons.prevArrow,
      nextArrow: buttons.nextArrow,
      slidesToShow: 2,
      slidesToScroll: 2
    });
  }

  const $hmhReviews = $(".hmh__reviews");
  if ($hmhReviews.length) {
    $hmhReviews.slick({
      infinite: false,
      dots: true,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1
    });
  }

  const $pdpMainAll = $(".pdp-main__images .product-images[data-images='all']");
  if ($pdpMainAll.length) {
    $pdpMainAll.slick({
      infinite: true,
      dots: true,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1
    });
  }

  const $pdpMainThumbs = $(".pdp-main__images .product-images[data-images='remaining'].thumb");
  if ($pdpMainThumbs.length) {
    $pdpMainThumbs.slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      variableWidth: false
    });
  }

  const $TPReviews = $(".tp-reviews__cards");
  const tpReviewsOptions = {
    infinite: true,
    dots: false,
    arrows: true,
    prevArrow: buttons.prevArrow,
    nextArrow: buttons.nextArrow,
    slidesToShow: 1,
    slidesToScroll: 1
  };
  const tpReviewsDesktopOptions = $(".tp-reviews__cards.desktop-carousel").length
    ? {
        infinite: true,
        dots: false,
        arrows: true,
        prevArrow: buttons.prevArrow,
        nextArrow: buttons.nextArrow,
        slidesToShow: 2,
        slidesToScroll: 2
      }
    : null;

  const $productShowcase = $(".product-showcase__products:not(.pdp-description)");
  const productShowcaseOptions = {
    infinite: true,
    dots: true,
    arrows: true,
    prevArrow: buttons.prevArrow,
    nextArrow: buttons.nextArrow,
    slidesToShow: 2,
    slidesToScroll: 2
  };

  const $ingredientsCarousel = $(".ingredients__items--carousel");
  const ingredientsCarouselOptions = {
    infinite: true,
    dots: true,
    arrows: true,
    prevArrow: buttons.prevArrow,
    nextArrow: buttons.nextArrow,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  const $athletesCarousel = $(".bd_aths_cont.slick-progress");
  const athletesCarouselOptions = {
    infinite: true,
    dots: true,
    arrows: true,
    prevArrow: buttons.prevArrow,
    nextArrow: buttons.nextArrow,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "30px"
  };

  if ($TPReviews.length) {
    handleResponsiveCarousel($TPReviews, tpReviewsOptions, 1024, tpReviewsDesktopOptions);
  }
  if ($productShowcase.length) {
    handleResponsiveCarousel($productShowcase, productShowcaseOptions, 753);
  }
  if ($ingredientsCarousel.length) {
    handleResponsiveCarousel($ingredientsCarousel, ingredientsCarouselOptions, 753);
  }
  if ($athletesCarousel.length) {
    handleResponsiveCarousel($athletesCarousel, athletesCarouselOptions, 753);
  }

  // ===== Video reviews =====
  const $videoReviewVideos = $(".video-reviews__video");
  if ($videoReviewVideos.length) {
    $(".video-reviews__video-button.play, .video-reviews__video").on("click", function () {
      const $videoWrapper = $(this).is(".video-reviews__video") ? $(this) : $(this).closest(".video-reviews__video");
      const $video = $videoWrapper.find("video");

      if (!$video.length) return;

      const videoEl = $video.get(0);

      if (!videoEl.paused) {
        videoEl.pause();
        $videoWrapper.removeClass("play").find(".video-reviews__video-button.pause").hide();
        $videoWrapper.find(".video-reviews__video-button.play").css("display", "flex");
        return;
      }

      $videoReviewVideos.each(function () {
        const $otherWrapper = $(this);
        const $otherVideo = $otherWrapper.find("video");
        if (!$otherVideo.length) return;
        if ($otherVideo.get(0) !== videoEl) {
          $otherVideo.prop("muted", true).get(0).pause();
          $otherWrapper.removeClass("play").find(".video-reviews__video-button.play").css("display", "flex");
          $otherWrapper.find(".video-reviews__video-button.pause").hide();
        }
      });

      $video.prop("muted", false).prop("volume", 0.5).get(0).play();
      if ($(this).is($videoWrapper)) {
        $videoWrapper.find(".video-reviews__video-button.play").hide();
      } else {
        $(this).hide();
      }
      $videoWrapper.addClass("play").find(".video-reviews__video-button.pause").css("display", "flex");
    });

    $(".video-reviews__video-button.play").on("click", function (e) {
      e.stopPropagation();
    });
  }

  // ===== Announcement Timer =====
  function AnnouncementTimer() {
    const $timerWrap = $(".announcement__timer");
    if (!$timerWrap.length) return;

    const $timer = $timerWrap.find(".timer");
    let time;

    const timerDate = $timerWrap.data("timer-date");
    if (timerDate) {
      const targetTime = new Date(timerDate + "T00:00:00");
      time = Math.floor((targetTime - new Date()) / 1000);
    } else {
      time = parseInt($timerWrap.data("time"), 10);
    }

    if (!Number.isFinite(time) || time <= 0) {
      $timerWrap.hide();
      return;
    }

    const update = function () {
      if (time < 0) {
        $timerWrap.hide();
        return;
      }
      const hours = Math.floor(time / 3600);
      const minutes = Math.floor((time % 3600) / 60);
      const seconds = time % 60;
      $timer.text(
        [hours, minutes, seconds]
          .map(function (v) {
            return v.toString().padStart(2, "0");
          })
          .join(":")
      );
      time--;
    };

    update();
    window.setInterval(update, 1000);
  }

  if ($(".announcement__timer").length) {
    AnnouncementTimer();
    $(".announcement__text a").on("click", function (e) {
      e.preventDefault();
      var text = $(this).text().trim();
      copyToClipboard(text);
      if (window.log && window.log.collapse) {
        window.log.collapse(text, "Copied to Clipboard");
      }
    });
  }

  // ===== Scroll to product =====
  $(".ScrollToProduct").on("click", function (e) {
    e.preventDefault();
    const targets = ["#product-main", ".bdp_form", "#buy-now"];
    const targetSelector = targets.find(function (t) { return $(t).length > 0; });
    if (!targetSelector) return;

    const $targetElements = $(targetSelector);
    const offset = 200;

    if ($targetElements.length > 1) {
      const scrollPos = $(window).scrollTop();
      const closest = $targetElements.toArray().reduce(function (prev, curr) {
        const prevDiff = Math.abs($(prev).offset().top - scrollPos);
        const currDiff = Math.abs($(curr).offset().top - scrollPos);
        return currDiff < prevDiff ? curr : prev;
      });
      $("html, body").animate({ scrollTop: $(closest).offset().top - offset }, 600);
    } else {
      $("html, body").animate({ scrollTop: $targetElements.offset().top - offset }, 600);
    }
  });

  // ===== Accordions =====
  const $accordions = $(".accordion > .accordion-item");
  if ($accordions.length) {
    $accordions.children(".accordion-panel").slideUp(0);
    $(".accordion > .accordion-item.is-active").children(".accordion-panel").slideDown(0);
    $accordions.on("click", function () {
      $(this).siblings(".accordion-item").removeClass("is-active").children(".accordion-panel").slideUp();
      $(this).toggleClass("is-active").children(".accordion-panel").slideToggle("ease-out");
    });
  }
});
